/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // #1482 — conta adicional de quem ja esta logado (modal do menu lateral). O cadastro publico
  // (`POST /api/v1/accounts`, com captcha e telefone) e outra porta, e mora em `v3/api/auth.js`.
  createAccount(data) {
    return axios.post(`${this.apiVersion}/additional_accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }
}

export default new AccountAPI();
